<template>
  <div class="login-container">
    <div class="overlay-text">
      <h2>欢迎使用快来看点系统</h2>
      <p>高效、安全、可靠的小说变现平台</p>
    </div>

    <div class="form-wrapper">
      <el-tabs v-model="activeTab" stretch>
        <el-tab-pane label="用户登录" name="login">
          <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef">
            <el-form-item prop="username">
              <el-input v-model="loginForm.username" placeholder="请输入账号" prefix-icon="User" clearable />
            </el-form-item>

            <el-form-item prop="password">
              <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" prefix-icon="Lock"
                show-password clearable />
            </el-form-item>

            <el-form-item>
              <el-checkbox v-model="rememberMe" label="记住密码" style="margin-bottom: 15px;" />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handleLogin" :loading="loading" style="width: 100%">
                登录
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="用户注册" name="register">
          <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef">
            <el-form-item prop="name">
              <el-input v-model="registerForm.name" placeholder="请输入姓名" prefix-icon="User" clearable />
            </el-form-item>

            <el-form-item prop="phone">
              <el-input v-model="registerForm.phone" placeholder="请输入手机号" prefix-icon="Phone" clearable />
            </el-form-item>

            <el-form-item prop="email">
              <el-input v-model="registerForm.email" placeholder="请输入邮箱" prefix-icon="Message" clearable />
            </el-form-item>

            <el-form-item prop="password">
              <el-input v-model="registerForm.password" type="password" placeholder="请输入密码" prefix-icon="Lock"
                show-password clearable />
            </el-form-item>

            <el-form-item prop="confirmPassword">
              <el-input v-model="registerForm.confirmPassword" type="password" placeholder="请再次输入密码" prefix-icon="Lock"
                show-password clearable />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handleRegister" :loading="loading" style="width: 100%">
                注册
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    };

    return {
      activeTab: 'login',
      loading: false,
      rememberMe: false,
      loginForm: {
        username: '',
        password: ''
      },
      registerForm: {
        name: '',
        phone: '',
        email: '',
        password: '',
        confirmPassword: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      registerRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
      }
    }
  },
  methods: {

    async handleLogin() {
      this.$refs.loginFormRef.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await this.$axios.post(`api/user/login`, {
              username: this.loginForm.username,
              password: this.loginForm.password
            });
            console.log(response)
            if (response.code == 0) {
              this.$message.error(response.msg || '登录失败');
              return;
            }
            const token = response.data.userinfo.token;
            const userInfo = response.data.userinfo;
            console.log('登录成功，token:', token);
            this.$store.dispatch('setToken', token);
            this.$store.dispatch('setUserInfo', userInfo);

            if (this.rememberMe) {
              localStorage.setItem('savedUsername', this.loginForm.username);
              localStorage.setItem('savedPassword', this.loginForm.password);
            } else {
              localStorage.removeItem('savedUsername');
              localStorage.removeItem('savedPassword');
            }
            this.$message.success(response.msg || '登录成功');
            this.$router.push('/dashboard');
          } catch (error) {
            console.error('登录失败:', error);
            this.$message.error(error?.data?.msg || '登录失败');
          } finally {
            this.loading = false;
          }
        }
      });
    },
    async handleRegister() {
      this.$refs.registerFormRef.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await this.$axios.post(`api/user/register`, {
              name: this.registerForm.name,
              phone: this.registerForm.phone,
              email: this.registerForm.email,
              password: this.registerForm.password
            });
            if (response.code == 0) {
              this.$message.error(response.msg || '注册失败');
              return;
            }
            this.$message.success('注册成功');
            this.activeTab = 'login';
            this.$refs.registerFormRef.resetFields();


          } catch (error) {
            this.$message.error(error.response?.data?.msg || '注册失败');
          } finally {
            this.loading = false;
          }
        }
      });
    },
    loadSavedCredentials() {
      const username = localStorage.getItem('savedUsername');
      const password = localStorage.getItem('savedPassword');
      if (username && password) {
        this.loginForm.username = username;
        this.loginForm.password = password;
        this.rememberMe = true;
      }
    }
  },
  mounted() {
    this.loadSavedCredentials();
    if (this.$store.getters.token) {
      this.$router.push('/home');
    }
  }
}
</script>

<style scoped>
.login-container {
  position: relative;
  height: 100vh;
  background: url('@/assets/login-bg.png') no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.form-wrapper {
  width: 100%;
  max-width: 380px;
  padding: 30px;
  background:#fff;
  backdrop-filter: blur(10px);
  border-radius: 20px;
  margin-top: 20px;
}

.overlay-text {
  color: white;
  max-width: 400px;
  text-align: center;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  margin-bottom: 20px;
}

@media (min-width: 992px) {
  .login-container {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10%;
  }

  .form-wrapper {
    position: static;
    transform: none;
    margin-top: 0;
  }

  .overlay-text {
    position: static;
    transform: none;
    text-align: left;
    margin-bottom: 0;
  }
}

.overlay-text h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #FFFFFF;
  font-weight: bold;
}

.overlay-text p {
  font-size: 1.2rem;
  color: #fff;
}

.el-tabs__item {
  font-size: 18px;
  color: #666;
}

.el-tabs__item.is-active {
  color: #FFFFFF;
}

.el-tabs__active-bar {
  background-color: #6db5f8;
}

.el-button--primary {
  background-color: #6db5f8;
  border-color: #6db5f8;
  border-radius: 20px;
  font-size: 16px;
  height: 45px;
}

.el-button--primary:hover {
  background-color: #6db5f8;
  border-color: #6db5f8;
}

.el-input {
  --el-input-border-radius: 20px;
  --el-input-height: 48px;
  --el-input-bg-color: rgba(255, 255, 255, 0.8);
  --el-input-border-color: rgba(160, 160, 160, 0.5);
  --el-input-hover-border-color: #6db5f8;
  --el-input-focus-border-color: #6db5f8;
  margin-bottom: 20px;
}

.el-input__inner {
  padding-left: 40px;
  color: #666;
  font-size: 16px;
}

.el-input__prefix {
  color: #6db5f8;
  left: 12px;
}

.el-input__suffix {
  right: 12px;
}

.el-input__wrapper {
  box-shadow: 0 2px 8px rgba(255, 133, 162, 0.1);
}

.el-input__wrapper:hover {
  box-shadow: 0 2px 12px rgba(255, 133, 162, 0.2);
}

.el-input__wrapper.is-focus {
  box-shadow: 0 2px 12px rgba(255, 133, 162, 0.3);
}

.el-form-item {
  margin-bottom: 25px;
}
</style>
